<template>
  <table class="checklist-table">
    <thead>
      <tr>
        <th colspan="3">
          <v-select
            :items="users"
            v-model="form.responsiblePerson"
            item-text="username"
            item-value="username"
            label="Responsible Person"
          ></v-select>
        </th>
        <th colspan="13">
        </th>
      </tr>
      <tr>
        <th>
          <span class="d-block">Location</span>
          (Add location of fire extenguisher)
        </th>
        <th>
          Type
        </th>
        <th>
          Weight
        </th>
        <th>
          Jan
        </th>
        <th>
          Feb
        </th>
        <th>
          Mar
        </th>
        <th>
          Apr
        </th>
        <th>
          May
        </th>
        <th>
          Jun
        </th>
        <th>
          Jul
        </th>
        <th>
          Aug
        </th>
        <th>
          Sep
        </th>
        <th>
          Oct
        </th>
        <th>
          Nov
        </th>
        <th>
          Dec
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, index) in items" :key="index">
        <td>
          <v-select
            :items="locations"
          ></v-select>
        </td>
        <td>
          <v-select
            :items="types"
          ></v-select>
        </td>
        <td>
          <v-text-field
          ></v-text-field>
        </td>
        <td v-for="i in 12" :key="i" class="text-center">
          <v-checkbox></v-checkbox>
        </td>
      </tr>
      <tr>
        <td colspan="15">
          <v-btn color="success" @click="items.push({})">Add Row</v-btn>
        </td>
      </tr>
      <tr>
        <td colspan="3">
          Date Completed
        </td>
        <td v-for="i in 12" :key="i" class="text-center">
          <DateField />
        </td>
      </tr>
      <tr>
        <td colspan="3">
          Signature
        </td>
        <td v-for="i in 12" :key="i" class="text-center">
          <PinDialog label="Sign" role="Process Controller" title="" />
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { mapActions } from 'vuex';
import DateField from '@/modules/processing/components/DateField.vue';
import PinDialog from '@/modules/processing/components/PinDialog.vue';

export default {
  name: 'FireEquipmentHealth',
  components: {
    DateField,
    PinDialog,
  },
  props: {
    checklist: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: {
        responsiblePerson: undefined,
      },
      items: [{}],
      locations: [
        'Workshop',
        'Inside Bleach Store',
        'Outside Bleach Store',
      ],
      types: [
        'DCP',
        'Foam',
        'CO2',
      ],
      users: [],
    };
  },
  methods: {
    ...mapActions('userPins', ['LOAD_usernames']),
  },
  async mounted() {
    this.users = await this.LOAD_usernames();
  },
};
</script>
